import actions from "src/actions/Exam";

import DefaultOptionDetails from "./DefaultOptionDetails";

function OptionDetails({ question, state, dispatch, details, folders }) {
	const { settings } = state;

	return (
		<DefaultOptionDetails
			settings={settings}
			question={question}
			folders={folders}
			dispatch={dispatch}
			actions={actions}
			details={details}
		/>
	);
}

export default OptionDetails;
